import { VStack } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

import { ProfitabilityWithIcon } from '../../../../../../../../../../components/ProfitabilityWithIcon';
import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../../components/TableContent';
import { tableHead } from '../../constants';

import { PortfolioAssetItemProps } from '.';

const getFlex = (index: number) => {
  const currentHead = tableHead.find((_, itemIndex) => itemIndex === index);
  return currentHead?.flex || 1;
};

export const PortfolioAssetItemDesktop: React.FC<PortfolioAssetItemProps> = ({ asset }) => {
  return (
    <TableContent direction="row" position="relative" pl="inline.xxxs" pr="inline.xxxs">
      <Box
        position="absolute"
        top={0}
        left={0}
        bottom={0}
        w="4px"
        backgroundColor="product.rendavariavel"
        borderTopLeftRadius="full"
        borderBottomLeftRadius="full"
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <VStack space="stack.quarck">
          <TableContentItemText fontSize="md" variant="semibold">
            {asset.assetNameNormalized}
          </TableContentItemText>
          <TableContentItemText color="neutral.medium" fontSize="xs">
            {asset.assetCategoryNormalized}
          </TableContentItemText>
        </VStack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{asset.grossValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{asset.appliedValueNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{asset.quantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <ProfitabilityWithIcon profitability={asset.profitabilityNormalized} />
      </TableContentItemColumn>
    </TableContent>
  );
};
